import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_PAYOUT_QUANTITY = "GET_PAYOUT_QUANTITY";
export const GET_PAYOUT_QUANTITY_SUCCESS = "GET_PAYOUT_QUANTITY_SUCCESS";
export const GET_PAYOUT_QUANTITY_FAILED = "GET_PAYOUT_QUANTITY_FAILED";

export const GET_PAYOUT_HEADER = "GET_PAYOUT_HEADER";
export const GET_PAYOUT_HEADER_SUCCESS = "GET_PAYOUT_HEADER_SUCCESS";
export const GET_PAYOUT_HEADER_FAILED = "GET_PAYOUT_HEADER_FAILED";

export const GET_PAYOUT_HEADER_CSV = "GET_PAYOUT_HEADER_CSV";
export const GET_PAYOUT_HEADER_CSV_SUCCESS = "GET_PAYOUT_HEADER_CSV_SUCCESS";
export const GET_PAYOUT_HEADER_CSV_FAILED = "GET_PAYOUT_HEADER_CSV_FAILED";

export const GET_PAYOUT_ITEM_CSV = "GET_PAYOUT_ITEM_CSV";
export const GET_PAYOUT_ITEM_CSV_SUCCESS = "GET_PAYOUT_ITEM_CSV_SUCCESS";
export const GET_PAYOUT_ITEM_CSV_FAILED = "GET_PAYOUT_ITEM_CSV_FAILED";

export const SHOW_ALERT_PAYOUT = "SHOW_ALERT_PAYOUT";
export const HIDE_ALERT_PAYOUT = "HIDE_ALERT_PAYOUT";

/** Clears payout tiles only (does not dispatch global RESET_DATA to other reducers). */
export const RESET_PAYOUT_DASHBOARD_STATE = "RESET_PAYOUT_DASHBOARD_STATE";

export function resetPayoutDashboardState() {
  return { type: RESET_PAYOUT_DASHBOARD_STATE };
}

export function fetchShowAlertPayout(component) {
  return {
    type: SHOW_ALERT_PAYOUT,
    component: component,
  };
}

export function hideAlertPayout() {
  return {
    type: HIDE_ALERT_PAYOUT,
  };
}

export function triggerFetchPayoutQuantity(obj, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutQty`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_PAYOUT_QUANTITY,
      successAction: GET_PAYOUT_QUANTITY_SUCCESS,
      failedAction: GET_PAYOUT_QUANTITY_FAILED,
      type: "POST",
      signal: signal,
      // callback: obj.callback,
      // extraData: obj.extraData
    };
    makeAPICall(params);
  };
}

export function triggerFetchPayoutHeader(obj, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutHdr`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_PAYOUT_HEADER,
      successAction: GET_PAYOUT_HEADER_SUCCESS,
      failedAction: GET_PAYOUT_HEADER_FAILED,
      type: "POST",
      signal: signal,
      // callback: obj.callback,
      // extraData: obj.extraData
    };
    makeAPICall(params);
  };
}

export function triggerFetchPayoutHeaderCSV(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutHeaderCSV`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_PAYOUT_HEADER_CSV,
      successAction: GET_PAYOUT_HEADER_CSV_SUCCESS,
      failedAction: GET_PAYOUT_HEADER_CSV_FAILED,
      type: "POST",
      callback: callback,
      errCallback: errCallback,
      // extraData: obj.extraData
    };
    makeAPICall(params);
  };
}

export function triggerFetchPayoutItemCSV(
  obj,
  responseType,
  callback,
  errCallback,
  signal
) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutItemCSV`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_PAYOUT_ITEM_CSV,
      successAction: GET_PAYOUT_ITEM_CSV_SUCCESS,
      failedAction: GET_PAYOUT_ITEM_CSV_FAILED,
      type: "POST",
      responseType: responseType,
      callback: callback,
      errCallback: errCallback,
      signal: signal,
      // extraData: obj.extraData
    };
    makeAPICall(params);
  };
}

export const triggerFetchDownloadList = (obj) => {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}downloads`,
      dispatch,
      headers: obj.headers,
      type: "POST",
      callback: obj.callback,
      errCallback: obj.errCallback,
    };
    makeAPICall(params);
  };
};

export const triggerDownloadFile = (obj) => {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}downloadHeaderLineItem`,
      dispatch,
      headers: obj.headers,
      type: obj.type ?? "GET",
      callback: obj.callback,
      errCallback: obj.errCallback,
      params: obj.params,
    };
    makeAPICall(params);
  };
};
